import { Button, useToast } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import { formatRoasVectorForCopy } from './calc/roasSaturation';

function CopyRoasVectorButton({ vectorPct, label }) {
  const toast = useToast();
  const copyText = formatRoasVectorForCopy(vectorPct);

  const onCopy = async () => {
    if (!copyText) {
      return;
    }
    try {
      await navigator.clipboard.writeText(copyText);
      toast({ title: 'ROAS vector copied', status: 'success', duration: 2000 });
    } catch {
      toast({ title: 'Copy failed', status: 'error', duration: 2000 });
    }
  };

  return (
    <Button
      size="xs"
      variant="outline"
      colorScheme="purple"
      onClick={onCopy}
      isDisabled={!copyText}
    >
      {label}
    </Button>
  );
}

CopyRoasVectorButton.propTypes = {
  vectorPct: PropTypes.arrayOf(PropTypes.number),
  label: PropTypes.string,
};

CopyRoasVectorButton.defaultProps = {
  label: 'Copy vector',
};

export default CopyRoasVectorButton;
